import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { createCanBoundTo } from "@casl/react";
import { ability } from "./ability";

export const Can = createCanBoundTo(ability) as any;
